class HeaderLanding {
  constructor() {
    this.header = document.querySelector('.header-landing');
    if (!this.header) return;

    this.burger = this.header.querySelector('[data-landing-burger]');
    this.drawer = document.querySelector('[data-landing-drawer]');
    this.overlay = this.header.querySelector('[data-landing-overlay]');
    this.anchorLinks = document.querySelectorAll('[data-anchor-link]');

    this.lastScrollY = window.scrollY;
    this.scrollThreshold = 300;

    this.initSmoothScroll();
    this.initScrollBehavior();
    this.initBurger();
    this.initActiveHighlight();
  }

  initSmoothScroll() {
    this.anchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();

        const scrollToTarget = () => {
          const headerHeight = this.header.offsetHeight + 20;
          const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth',
          });
        };

        if (this.drawer && this.drawer.classList.contains('is-open')) {
          this.closeDrawer();
          this.drawer.addEventListener('transitionend', () => scrollToTarget(), { once: true });
        } else {
          scrollToTarget();
        }
      });
    });
  }

  initScrollBehavior() {
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > this.scrollThreshold) {
      if (currentScrollY > this.lastScrollY) {
        this.header.classList.add('header-landing--hidden');
      } else {
        this.header.classList.remove('header-landing--hidden');
      }
    } else {
      this.header.classList.remove('header-landing--hidden');
    }

    this.lastScrollY = currentScrollY;
  }

  initBurger() {
    if (!this.burger || !this.drawer) return;

    this.burger.addEventListener('click', () => {
      const isOpen = this.drawer.classList.contains('is-open');
      if (isOpen) {
        this.closeDrawer();
      } else {
        this.openDrawer();
      }
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeDrawer());
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
        this.closeDrawer();
      }
    });
  }

  openDrawer() {
    this.drawer.classList.add('is-open');
    this.burger.classList.add('is-open');
    this.burger.setAttribute('aria-expanded', 'true');
    if (this.overlay) this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    this.drawer.classList.remove('is-open');
    this.burger.classList.remove('is-open');
    this.burger.setAttribute('aria-expanded', 'false');
    if (this.overlay) this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  initActiveHighlight() {
    const sections = [];

    this.anchorLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      const target = document.querySelector(href);
      if (target) {
        sections.push({ id: href.substring(1), el: target });
      }
    });

    if (sections.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;
          const links = document.querySelectorAll(`[data-anchor-link][href="#${id}"]`);

          links.forEach((link) => {
            if (entry.isIntersecting) {
              link.classList.add('is-active');
            } else {
              link.classList.remove('is-active');
            }
          });
        });
      },
      {
        rootMargin: '-20% 0px -60% 0px',
      }
    );

    sections.forEach((section) => {
      observer.observe(section.el);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HeaderLanding());
} else {
  new HeaderLanding();
}
